module.exports = __webpack_public_path__ + "img/瑞丰钢铁.5e359999.png";